import PageLayout from "@/components/PageLayout";

const SportkledingBedrukken = () => (
 <PageLayout
 title="Sportkleding bedrukken"
 metaDescription="Sportkleding bedrukken met rugnummers, spelersnamen en sponsorlogo's. Duurzame bedrukking voor elk team. Zeefdruk, transferdruk en sublimatie bij Magic Print."
 >
 <h1 className="text-3xl md:text-5xl font-bold mb-6">
 Sportkleding bedrukken
 </h1>

 <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
 Wil je jouw team een professionele uitstraling geven? Met sportkleding bedrukken maak je sportshirts, broeken en trainingspakken uniek én herkenbaar. Of het nu gaat om rugnummers, spelersnamen of sponsorlogo's: wij zorgen voor duurzame en scherpe bedrukking die lang meegaat.
 </p>

 <section className="mb-12">
 <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Rugnummers en namen op sportshirts</h2>
 <p className="text-muted-foreground mb-4">
 Bij teamsporten is het essentieel dat spelers goed herkenbaar zijn. Daarom is het bedrukken van rugnummer en naam de standaard voor elk sportshirt. Onze hoogwaardige druktechnieken zorgen ervoor dat de bedrukking zelfs na intensief sporten en vaak wassen mooi blijft.
 </p>
 <ul className="space-y-2 text-muted-foreground">
 <li> Persoonlijke uitstraling voor iedere speler</li>
 <li> Goed zichtbaar tijdens wedstrijden</li>
 <li> Keuze uit verschillende lettertypes en stijlen</li>
 </ul>
 </section>

 <section className="mb-12">
 <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Sponsorlogo's voor maximale zichtbaarheid</h2>
 <p className="text-muted-foreground mb-4">
 Sponsors zijn onmisbaar in de sportwereld. Met een duidelijk zichtbaar sponsorlogo op sportshirts of trainingspakken bied je jouw sponsoren de publiciteit die ze verdienen. Bedrukking kan op de borst, rug, mouw of broek worden geplaatst.
 </p>
 <ul className="space-y-2 text-muted-foreground">
 <li> Extra waarde voor je sponsoren</li>
 <li> Professionele uitstraling van het team</li>
 <li> Mogelijkheid om meerdere logo's te combineren</li>
 </ul>
 </section>

 <section className="mb-12">
 <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Waarom sportkleding laten bedrukken?</h2>
 <ul className="space-y-2 text-muted-foreground">
 <li>• Professionele look voor je team</li>
 <li>• Geschikt voor alle sporten: voetbal, hockey, hardlopen, wielrennen en meer</li>
 <li>• Duurzame bedrukking die tegen intensief gebruik kan</li>
 <li>• Combinatie van rugnummers, namen én sponsorlogo's mogelijk</li>
 </ul>
 </section>

 <section className="mb-12">
 <h2 className="text-2xl font-bold mb-4 text-[#0a2933]">Sportshirts bedrukken voor elk team</h2>
 <p className="text-muted-foreground">
 Of je nu een amateurteam, een sportvereniging of een bedrijfsteam hebt: met bedrukte sportshirts maak je altijd indruk. Dankzij moderne technieken zoals zeefdruk, transferdruk en sublimatie kunnen wij elk ontwerp op maat realiseren.
 </p>
 </section>
 </PageLayout>
);

export default SportkledingBedrukken;
